import React from 'react';
import type { V2Route } from '../units/types';

const ChatPage = React.lazy(() => import('./ChatPage'));

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  // 旧 pages/chat/ChatPage と同じ3つの経路。/chat/new → /chat/12 のように移っても同じ画面の部品で描く
  { path: 'chat/ai', Component: ChatPage },
  { path: 'chat/new', Component: ChatPage },
  { path: 'chat/:chatId', Component: ChatPage },
];

export default routes;
